import * as THREE from 'three';
import { FikoGrup } from '../FikoGrup';
import { FikoImporter } from '../FikoImporter';
import { FikoSahne } from '../FikoSahne';
import { FikoTakim } from "./FikoTakim";


export class FikoTakimTutucu extends FikoGrup {
    override type: "FikoTakimTutucu";
    // shape: THREE.Shape;
    // geometry: THREE.ExtrudeBufferGeometry;
    // material: THREE.MeshBasicMaterial = new THREE.MeshBasicMaterial({ color: 0x91918A, polygonOffset: true, polygonOffsetFactor: 1, polygonOffsetUnits: 1/*, depthTest:false,depthWrite:false */ })
    // govde: THREE.Mesh;
    // edges: THREE.EdgesGeometry;
    // lineSegments: THREE.LineSegments;
    // govdeMaterial: THREE.LineBasicMaterial = new THREE.LineBasicMaterial({ color: 0x636363 });
    // ucMaterial: THREE.LineBasicMaterial = new THREE.LineBasicMaterial({ color: 0xCCCC00 });

    constructor(public override sahne?: FikoSahne, tutucuKimlik: string = null) {
        super(sahne);
        // this.hazirla();
    }

    override hazirla() {
        // const importer = new FikoImporter(this);
        // importer.dosyadan(".wrl").then(() => {
        // });
        // this.translateZ(70);
    }

    guncelle() {

    }
}